import React, { useState } from "react";
import { Collapse } from "antd";
import "./style.css";
import { FormattedMessage } from "react-intl";
import AttachmentEInvoice from "./attachmentEInvoice";
import LinkedDocumentsPanel from "./linkedDocumentsPanel";
import { FEATURE_TOGGLE_LINKED_DOCUMENTS_SECTION } from "../../config";

const { Panel } = Collapse;

const DocumentDetailsCollapsedInfo = ({
  accountantSelected,
  accountantIdSelected,
  companySelected,
  clientIdSelected,
  documentId
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLinkedDocPanelOpen, setIsLinkedDocPanelOpen] = useState(false);

  const onClickCta = e => {
    setIsModalVisible(true);
    e.stopPropagation();
  };

  const onChangePanel = e => {
    const activeKey = e[0];
    if (activeKey === "1") {
      setIsLinkedDocPanelOpen(true);
    } else {
      setIsLinkedDocPanelOpen(false);
    }
  };

  let detailDocumentPanelsStructure = [
    {
      isLinked: false,
      header: function() {
        return (
          <div className="documentsCollapseHeader">
            <FormattedMessage id="documents.detail.attachmentSectionTitle" />
            {this.isLinked && (
              <div>
                <span
                  className="manageLinkedDocuments"
                  onClick={e => onClickCta(e)}
                >
                  <FormattedMessage id="documents.detail.manage" />
                </span>
              </div>
            )}
          </div>
        );
      },
      contentComponent: <AttachmentEInvoice />,
      index: 0
    },
    {
      isLinked: true,
      header: function() {
        return (
          <div className="documentsCollapseHeader">
            <FormattedMessage id="documents.detail.linkedDocumentsSectionTitle" />
            {this.isLinked && (
              <div>
                <span
                  className="manageLinkedDocuments"
                  style={{display: isLinkedDocPanelOpen ? "block" : "none"}}
                  onClick={e => onClickCta(e)}
                >
                  <FormattedMessage id="documents.detail.manage" />
                </span>
              </div>
            )}
          </div>
        );
      },
      contentComponent: (
        <LinkedDocumentsPanel
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          accountantSelected={accountantSelected}
          accountantIdSelected={accountantIdSelected}
          companySelected={companySelected}
          clientIdSelected={clientIdSelected}
          documentId={documentId}          
        />
      ),
      index: 1
    }
  ];

  const detailDocumentPanels = detailDocumentPanelsStructure.map(panel => {
    if (panel.index === 1 && FEATURE_TOGGLE_LINKED_DOCUMENTS_SECTION !== "true")
      return null;
    return (
      <Panel
        header={panel.header()}
        className="header-collapse-custom-panel-custom-panel"
        key={panel.index}
      >
        {panel.contentComponent}
      </Panel>
    );
  });

  return <Collapse bordered={false} onChange={e => onChangePanel(e)}>{detailDocumentPanels}</Collapse>;
};

export default DocumentDetailsCollapsedInfo;
